

.center
{

  text-align: center;
  margin: 4em;
}